"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6796],{

/***/ 26796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NavItem": function() { return /* reexport */ NavItem; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/atoms/NavItem/NavItem.tsx




var NavItem = function(param) {
    var url = param.url, name = param.name, onClick = param.onClick, _external = param.external, external = _external === void 0 ? false : _external;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        fontSize: [
            "0.875rem",
            null,
            null,
            "1rem"
        ],
        padding: "0 0.5rem",
        textTransform: "uppercase",
        onClick: function(e) {
            return onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        children: external ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: url,
            children: name
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: url,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                children: name
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/NavItem/index.ts



/***/ })

}]);